import { Breakpoints } from '@volkswagen-onehub/components-core';
import { ResponsiveResizeDimensions } from '@/hooks/useResizeResponsive';

export const isLargeDesktop = ({ innerWidth }: ResponsiveResizeDimensions) => {
  return innerWidth >= Breakpoints.b1920;
};

export const isDesktop = ({ innerWidth }: ResponsiveResizeDimensions) => {
  return innerWidth >= Breakpoints.b960;
};

export const isMobile = ({ innerWidth }: ResponsiveResizeDimensions) => {
  return innerWidth < Breakpoints.b960;
};
